import React from 'react';
import { Map, Marker, Popup, TileLayer } from 'react-leaflet';
import Typography from '@mui/material/Typography';
import L from 'leaflet';
import placeMarkerIcon from '../../../assets/img/placeMarker.svg';

import '../../../styles/map.css';

const PlaceMarker = new L.Icon({
    iconUrl: placeMarkerIcon,
    iconRetinaUrl: placeMarkerIcon,
    iconAnchor: null,
    shadowUrl: null,
    shadowSize: null,
    shadowAnchor: null,
    iconSize: new L.Point(25, 41),
    className: 'leaflet-marker-icon leaflet-zoom-animated leaflet-interactive',
    popupAnchor: [0, -10],
});

export const BasicMap = ({
    latitude,
    longitude,
    title,
    location,
    classes,
    ...props
}) => (
    <Map
        center={[latitude, longitude]}
        zoom={14}
        style={{ height: '100%', width: '100%' }}
    >
        <TileLayer
            attribution='&amp;copy <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        <Marker position={[latitude, longitude]} icon={PlaceMarker}>
            {title && (
                <Popup>
                    {location && (
                        <Typography variant="h6">{location}</Typography>
                    )}
                    <p>{title}</p>
                </Popup>
            )}
        </Marker>
    </Map>
);

export default BasicMap;
